import { render, staticRenderFns } from "./additionalNotes.vue?vue&type=template&id=7a6eb18f"
import script from "./additionalNotes.vue?vue&type=script&lang=js"
export * from "./additionalNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports